import React, { useEffect } from 'react'
import { privacyData } from '../data/scrollData'
import { useCustomScrollbar } from './useCustomScrollbar'

function toAlpha(n) {
  let value = n
  let label = ''

  do {
    label = String.fromCharCode(97 + (value % 26)) + label
    value = Math.floor(value / 26) - 1
  } while (value >= 0)

  return label
}

function PrivacyPopup({ isOpen, onClose, showCloseButton }) {
  const language = localStorage.getItem("appLanguage") || "en";
  const { contentRef, thumbRef, trackRef, onThumbPointerDown, onTrackClick, syncThumb } = useCustomScrollbar()

  useEffect(() => {
    if (typeof isOpen === "boolean" && !isOpen) return

    const rafId = window.requestAnimationFrame(syncThumb)
    const timeoutId = window.setTimeout(syncThumb, 100)

    return () => {
      window.cancelAnimationFrame(rafId)
      window.clearTimeout(timeoutId)
    }
  }, [isOpen, syncThumb])

  useEffect(() => {
    if (typeof isOpen !== "boolean" || !isOpen) return

    const previousOverflow = document.body.style.overflow

    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [isOpen])

  const popupContent = (
    <div>
      <div className="kp-rwd-header">
        <img src={language === "ta" ? "assets/images/privacy-policy-heading-tamil.webp" : "assets/images/privacy-policy-heading.webp"} className="kp-rwd-icon" alt="Privacy policy" />
      </div>
      <div className="kp-rwd-body-wrap">
        <div className="kp-scrollbox">
          <div className="kp-scrollbox__content" ref={contentRef}>
            {privacyData.map((section) => (
              <React.Fragment key={section.id}>
                <h2>{section.heading}</h2>
                {section.points.map((point, idx) => (
                  <p key={idx}>{toAlpha(idx)}. {point}</p>
                ))}
              </React.Fragment>
            ))}
          </div>

          <div
            className="kp-scrollbox__track"
            ref={trackRef}
            onClick={(e) => {
              e.stopPropagation()
              onTrackClick(e)
            }}
          >
            <div
              className="kp-scrollbox__thumb"
              ref={thumbRef}
              onPointerDown={(e) => {
                e.stopPropagation()
                onThumbPointerDown(e)
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )

  const shouldRenderAsModal = typeof isOpen === "boolean"
  const shouldShowCloseButton =
    typeof showCloseButton === "boolean"
      ? showCloseButton
      : shouldRenderAsModal

  if (shouldRenderAsModal) {
    if (!isOpen) return null

    return (
      <div className="tnc-popup-overlay" onClick={onClose}>
        <div className="tnc-popup" onClick={(e) => e.stopPropagation()}>
          {shouldShowCloseButton && (
            <button className="howtp-close-btn" onClick={onClose} type="button">
              <img src="assets/images/close-icon.webp" alt="Close" />
            </button>
          )}
          <div
            className="tnc-popup-body"
            onWheel={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            {popupContent}
          </div>
        </div>
      </div>
    )
  }

  return popupContent
}

export default PrivacyPopup
